import {
  Container,
  Styled404Logo,
  StyledAppLogo,
  StyledButton,
} from './PageNotFound.styles';
import AppLogo from '@assets/logos/swise_black_on_white.svg';
import App404Logo from '@assets/logos/404.png';
import { Text } from '@components';
import { FormattedMessage } from 'react-intl';
import { useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const PageNotFound: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleBackClick = () => navigate(-1);
  return (
    <Container>
      <StyledAppLogo alt='swise-logo' src={AppLogo} />
      <Styled404Logo alt='swise-404' src={App404Logo} />
      <Text variant='h3' fontWeight='fontWeightBold'>
        <FormattedMessage id='pageNotFound.pageNotFound' />
      </Text>
      <Text
        variant='h5'
        fontWeight='fontWeightRegular'
        color={theme.palette.black[500]}
        mt={6}
      >
        <FormattedMessage id='pageNotFound.message' />
      </Text>
      <StyledButton
        data-testid='page-not-found-back-button'
        onClick={handleBackClick}
      >
        <FormattedMessage id='misc.goBack' />
      </StyledButton>
    </Container>
  );
};

export default PageNotFound;
